import { jwtService } from "services";
import { setUserData } from "./user.actions";

export const CHECKTOKEN_ERROR = "CHECKTOKEN_ERROR";
export const CHECKTOKEN_SUCCESS = "CHECKTOKEN_SUCCESS";
export const CHECKTOKEN_START = "CHECKTOKEN_START";

export const checkTokenSubmit = ({ token, type, onSuccess }) => {
  return (dispatch, getState) => {
    const { login } = getState().auth;

    dispatch({
      type: CHECKTOKEN_START,
    });
    jwtService
      .signInWithToken({
        token,
        type,
        cellphone: login.cellphone && login.cellphone,
      })
      .then((user) => {
        dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: CHECKTOKEN_SUCCESS,
        });
      })
      .catch((error) => {
        return dispatch({
          type: CHECKTOKEN_ERROR,
          payload: error,
        });
      });
  };
};
